import $ from 'jquery';
import {AnimatePlusMinus} from './index.mjs';

$(document).ready(function(){
	var $currentAnswer,
		$currentElement,
		$acc_container,
		$acc_wrapper;

	$('.accordion li').on('click', function(event){
		var $icon = $(this).find('.laurea-icon');
		$acc_container = $(this);
		$acc_wrapper = $acc_container.closest('ul');
		$currentAnswer = $(this).find('.faq-answer');
		$currentElement = $(this).find('.faq-question');

		$acc_container.toggleClass('js-active-accordion-item');
		$($acc_wrapper).find("li").not($acc_container).removeClass('js-active-accordion-item');

		// $currentElement.find('.fas').toggleClass('fa-minus fa-plus');
		AnimatePlusMinus($icon, $acc_wrapper);
		$($acc_wrapper).find('.faq-question').not($currentElement).find('.fa-minus').toggleClass('fa-minus fa-plus');
		$currentAnswer.slideToggle('fast');
		$($acc_wrapper).find('.faq-answer').not($currentAnswer).slideUp('fast');

	});
});

